import { createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";

import { CockpitConversation } from "@/components/cockpit/cockpit-conversation";
import { EmptyState } from "@/components/ui/empty-state";
import { MessagesSquare } from "lucide-react";
import { cn } from "@/lib/utils";

import { ConversationsList } from "./conversas/-components/conversations-list";

export const Route = createFileRoute("/_app/conversas")({
	validateSearch: type({ "person?": "number.integer > 0" }),
	component: ConversationsPage,
});

function ConversationsPage() {
	const { person } = Route.useSearch();

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4">
			<h1 className="font-display text-2xl font-semibold text-foreground">Conversas</h1>
			<div className="flex min-h-0 flex-1 overflow-hidden workspace-frame">
				<div
					className={cn(
						"min-h-0 w-full shrink-0 md:w-64 xl:w-72",
						person !== undefined && "hidden md:flex",
					)}
				>
					<ConversationsList selected={person} />
				</div>
				<div className={cn("min-h-0 min-w-0 flex-1", person === undefined && "hidden md:flex")}>
					{person !== undefined && <CockpitConversation personId={person} />}
					{person === undefined && (
						<div className="m-auto p-6">
							<EmptyState icon={MessagesSquare} title="Selecione uma conversa" />
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
